import packageJson from '../../package.json';

/** Version affichée (footer, release notes). Priorité à REACT_APP_VERSION si définie au build. */
export const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version;

/** Version Mantine déclarée dans package.json (sans préfixe semver). */
export const MANTINE_VERSION = String(packageJson.dependencies?.['@mantine/core'] || '')
  .replace(/^[^\d]*/, '')
  .replace(/[^0-9.].*$/, '') || '9';
